import {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {emptyWebConfig, PhoneNumber, Source, WebConfig} from '@types';
import axios, {AxiosResponse} from 'axios';

export const WebConfigContext = createContext<WebConfig | undefined>(undefined);

export const useWebConfigContext = (): WebConfig => {
    const context = useContext(WebConfigContext);

    if (!context) {
        throw new Error('useWebConfigContext must be used within the WebConfigContext.Provider');
    }

    return context;
};

export const useWebConfigContextValue = (): WebConfig => {
    const [webConfig, setWebConfig] = useState<WebConfig>(emptyWebConfig);

    const getWebConfig = useCallback(async (): Promise<void> => {
        const {data: webConfig}: AxiosResponse<WebConfig> = await axios.get('/api/web-config');
        const sources: Source[] = generateKeys(webConfig.sources);
        const phoneNumbers: PhoneNumber[] = generateKeys(webConfig.phoneNumbers);
        setWebConfig({...webConfig, sources, phoneNumbers});
    }, [setWebConfig]);

    useEffect(() => {
        getWebConfig();
    }, [getWebConfig]);

    return useMemo(() => webConfig, [webConfig]);
};

const generateKeys = <T>(arr: T[]) => arr.map((v, idx) => ({...v, key: idx.toString()}))
